var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-input-group',[_c('b-input',{staticClass:"range-input",attrs:{"type":"number"}}),_c('div',{staticStyle:{"margin-right":"10px"}},[_vm._v("-")]),_c('b-input',{staticClass:"range-input",attrs:{"type":"number"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }